// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yCXn","content":"styles_content__3_QnC"};